module dg.navigation {
    angular.module('dg.navigation', []);
}